define('bindingHandlers/viewSwitch',[
    'lib/knockout',
    'jquery'
], function (ko, $) {
    'use strict';

    var BINDING_NAME = 'view-switch-binding';
    var EVENT_NAMESPACE = '.' + BINDING_NAME;
    var ACTIVE_CLASS = 'is-active';

    var setBindingOption = function (element, parameter, value) {
        ko.utils.domData.get(element, BINDING_NAME)[parameter] = value;
    };

    var getBindingOption = function (element, parameter) {
        return ko.utils.domData.get(element, BINDING_NAME)[parameter];
    };

    var isOpen = function (switchedView, viewName) {
        return (switchedView.getActiveView() == viewName);
    };

    var cleanupBinding = function (element) {
        $(element).off(EVENT_NAMESPACE);
        getBindingOption(element, 'classComputed').dispose();
    };

    var storeOptions = function (element, valueAccessor) {
        var parameters = valueAccessor();
        var switchedView = ko.utils.unwrapObservable(parameters.view);
        var targetViewName = ko.utils.unwrapObservable(parameters.name);
        var toggle = ko.utils.unwrapObservable(parameters.toggle) || false;
        setBindingOption(element, 'switchedView', switchedView);
        setBindingOption(element, 'viewName', targetViewName);
        setBindingOption(element, 'toggle', toggle);
    };

    /**
     * A binding for quick management of the active view on a switched view.
     * Useful for implementing tab-like interfaces.
     *
     * <a data-bind="
     *   viewSwitch: {
     *      view: someSwitchedView,
     *      name: subViewToActivate,
     *      toggle: true
     *   }
     * " href="#"></a>
     *
     * The binding takes three parameters:
     * view -> the switched view the element will control
     * name -> the name of the sub-view on the switched view that will
     *         be activated or toggled when the element is clicked.
     * toggle -> boolean indicating if clicking on the element will de-activate
     *           the current view if it is already active. (defaults to false)
     *@exports(bindingHandlers/viewSwitch)
     */
    ko.bindingHandlers.viewSwitch = {
        init: function(element, valueAccessor) {
            ko.utils.domData.set(element, BINDING_NAME, {});
            storeOptions(element, valueAccessor);

            $(element).on('click' + EVENT_NAMESPACE, function(event) {
                event.preventDefault();
                var switchedView = getBindingOption(element, 'switchedView');
                var viewName = getBindingOption(element, 'viewName');
                var toggle = getBindingOption(element, 'toggle');

                if (isOpen(switchedView, viewName) && toggle) {
                    switchedView.setActiveView(null);
                } else {
                    switchedView.setActiveView(viewName);
                }
            });

            var classComputed = ko.computed(function () {
                var switchedView = getBindingOption(element, 'switchedView');
                var viewName = getBindingOption(element, 'viewName');
                if (switchedView.getActiveView() == viewName) {
                    $(element).addClass(ACTIVE_CLASS);
                } else {
                    $(element).removeClass(ACTIVE_CLASS);
                }
            });

            setBindingOption(element, 'classComputed', classComputed);

            ko.utils.domNodeDisposal.addDisposeCallback(element, cleanupBinding);
        },

        update: function (element, valueAccessor) {
            storeOptions(element, valueAccessor);
        }
    };
});

